import { useState, useEffect } from "react";
import { PiggyBank, Briefcase, Crown, ArrowRight, Check, Sparkles } from "lucide-react";

const LINKS = {
  ahorrar: "/plandeagencias",
  agente: "/plandeagencias",
  agencia: "/plandeagencias",
  compensacion: "/plandecompensacion",
  leads: "/leads",
  licencias: "/licencias",
  asesor: "https://wa.me/message/",
};

const CARDS = [
  { key: "agente", Icon: Briefcase, kicker: "El que trabaja en el negocio", title: "Quiero ser Agente de Viajes", sub: "Empiezas sin barreras, aprendes y cobras tu primera comisión vendiendo viajes.", single: "25%", valueLabel: "de comisión por venta", note: "El primer paso de la industria", iconBg: "#E3F3D6", iconColor: "#6FB63C", ring: "#6FB63C" },
  { key: "agencia", Icon: Crown, kicker: "El que es DUEÑO del negocio", title: "Quiero tener mi propia Agencia", sub: "Construyes un activo que trabaja para ti. Desbloqueas override por cada agente que formas.", range: ["50%", "80%"], valueLabel: "de comisión · desbloqueas override", note: "4 niveles para escalar", iconBg: "#DCEBFB", iconColor: "#2F7FD0", ring: "#2F7FD0" },
];

const DETAIL_AHORRAR = {
  accent: "#E8912A",
  kicker: "El viajero inteligente",
  head: "Viaja con precios de agente.",
  sub: "Sin vender nada: activas la plataforma solo para tus propias vacaciones y ahorras en cada viaje.",
  note: "Solo para viajar",
  planName: "Plan Viajero",
  planDesc: "Para ti que no quieres vender: usa la plataforma solo para tus propias vacaciones. Tú no vendes: usas la plataforma para tus propios viajes.",
  includes: [
    "Acceso a la plataforma de viajes para uso personal",
    "Precios de agente en hoteles, vuelos y experiencias",
    "Reserva tus propias vacaciones cuando quieras",
    "Sin obligación de vender ni de formar agentes",
    "Soporte por email",
    "Actualizaciones de por vida",
  ],
  price: "$97",
  priceLabel: "Inversión única",
  cta: "Quiero viajar con precios de agente",
  link: LINKS.ahorrar,
  upsell: "¿Y si además quieres ganar dinero? Con un pequeño paso más puedes empezar a vender viajes y cobrar comisión.",
};

const DETAIL_AGENTE = {
  accent: "#6FB63C",
  kicker: "Camino del Agente",
  head: "Hoy das tu primer paso.",
  sub: "Entras a la industria sin barreras. Aprendes, vendes y cobras tu primera comisión.",
  note: "Para empezar a ganar · Punto de entrada",
  planName: "Plan Cero",
  planDesc: "Hoy das tu primer paso en la industria de viajes.",
  big: "25%",
  bigLabel: "de comisión por venta",
  includes: [
    "Plataforma de Agente de Viajes",
    "Capacitación para lograr tu primera venta",
    "Comisión del 25% en cada venta que cierras",
    "Soporte por email",
    "Actualizaciones de por vida",
  ],
  price: "$197",
  priceLabel: "Inversión única",
  cta: "Quiero empezar como Agente",
  link: LINKS.agente,
  upsell: "¿Listo para ser DUEÑO? Un agente cobra una comisión. Un dueño cobra, además, el override de cada agente que forma y plataformas que facturan solas.",
};

const OVERRIDE_STEPS = [
  { n: "1.", t: "Enseñas a alguien", d: "Le das su propia agencia." },
  { n: "2.", t: "Esa persona vende", d: "Ella cierra sus viajes." },
  { n: "3.", t: "A ti te pagan", d: "Ganas sin vender nada." },
];

const PLANS = [
  {
    key: "starter", vibe: "Despega", name: "Starter", accent: "#45A0EE", blue: false,
    level: "Nivel 1 de 3 — Starter",
    headline: "La agencia es TUYA. Dejas de trabajar para alguien.",
    big: "50%", bigLabel: "de comisión por venta",
    overrideLabel: "OVERRIDE 25%", overrideDesc: "Ganas override por cada agente que formas. Desbloqueas el OVERRIDE: empiezas a ganar por tu equipo.",
    newTitle: "Incluye desde el día uno",
    newItems: [
      "Plataforma Agencia de Viajes",
      "Override del 25% sobre cada agente que registras",
      "Apertura de Agentes Viajeros y Plan Cero",
      "Marketing de afiliados comisionable",
      "Capacitación incluida",
      "Soporte por email",
      "Actualizaciones de por vida",
    ],
    also: null,
    price: "$697", cta: "Pasar al siguiente nivel",
  },
  {
    key: "pro", vibe: "Acelera", name: "Profesional", accent: "#8B5CF6", blue: false, popular: true,
    level: "Nivel 2 de 3 — Profesional · El más elegido",
    headline: "El más elegido: tu negocio ya camina con sistema y soporte.",
    big: "60%", bigLabel: "de comisión por venta",
    overrideLabel: "OVERRIDE hasta 35%", overrideDesc: "+10% sobre agentes Starter. Agregas Certificados de Viaje y Asesorías Migratorias.",
    newTitle: "Nuevo en este nivel",
    newItems: [
      "Plataforma Certificados de Viaje",
      "Plataforma Asesorías Migratorias",
      "250 Certificados Orlando + Miami cada mes (no acumulativos)",
      "Override hasta 35% + 10% sobre agentes Starter",
      "Capacitación premium",
      "Soporte prioritario",
      "Comunidad exclusiva",
    ],
    also: ["Plataforma Agencia de Viajes", "Override del 25% sobre cada agente que registras", "Apertura de Agentes Viajeros y Plan Cero", "Marketing de afiliados comisionable", "Capacitación incluida", "Soporte por email", "Actualizaciones de por vida"],
    alsoTitle: "También incluye todo lo de Starter:",
    price: "$1,497", cta: "Pasar al siguiente nivel",
  },
  {
    key: "empire", vibe: "El Imperio", name: "Travel Empire", accent: "#8CE84C", blue: true,
    topBadge: "El lugar donde todos quieren estar",
    level: "Nivel 3 de 3 — Travel Empire · El lugar donde todos quieren estar",
    headline: "Ya no cierras tú: un equipo te agenda y tú solo cobras. Aquí tienes una máquina, no un trabajo.",
    big: "80%", bigLabel: "de comisión por venta",
    overrideLabel: "OVERRIDE hasta 55%", overrideDesc: "Override sobre TODOS los niveles de tu red.",
    newTitle: "Nuevo en este nivel — todo desbloqueado",
    newItems: [
      "Plataforma Club Vacacional",
      "Plataforma de seguros de viaje Assist Card",
      "Certificados de Viaje ILIMITADOS y GRATIS",
      "Apertura de agentes Viajeros y Plan Cero ILIMITADA y GRATIS",
      "Override hasta 55% — sobre todos los niveles",
      "Setter Squad: equipo humano que te agenda las citas",
      "Red de agencias que te pagan 10% por sus reservas",
      "Negocio OPC: $300 USD por cada invitado calificado",
      "Tons of Leads: tu máquina de clientes 24/7",
      "Diploma FGU + Curso Amadeus GDS incluidos",
      "Capacitación directa con Carlos · atención inmediata",
      "Soporte directo + comunidad súper exclusiva",
      "Franquicia Travel Empire · Círculo de Ventas Elite",
    ],
    also: ["Plataforma Agencia de Viajes", "Override del 25% sobre cada agente que registras", "Apertura de Agentes Viajeros y Plan Cero", "Marketing de afiliados comisionable", "Capacitación incluida", "Soporte por email", "Actualizaciones de por vida", "Plataforma Certificados de Viaje", "Plataforma Asesorías Migratorias", "250 Certificados Orlando + Miami cada mes (no acumulativos)", "Override hasta 35% + 10% sobre agentes Starter", "Capacitación premium", "Soporte prioritario", "Comunidad exclusiva"],
    alsoTitle: "También incluye todo lo de Profesional:",
    price: "$4,995", cta: "Quiero mi Imperio", last: true,
  },
];

const Bullet = ({ children, color }) => (
  <li className="flex items-start gap-2.5 text-sm leading-relaxed">
    <span className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center" style={{ backgroundColor: `${color}22` }}>
      <Check className="h-3 w-3" style={{ color }} />
    </span>
    <span className="text-slate-600">{children}</span>
  </li>
);

// Marcas públicas (wordmark chips en sus colores) + comparación de precios
const PUBLIC_BRANDS = [
  { name: <span>Booking<span className="opacity-80">.com</span></span>, bg: "#003580", fg: "#fff" },
  { name: <span>despegar</span>, bg: "#1e4fd8", fg: "#ffd400" },
  { name: <span>expedia</span>, bg: "#111c3a", fg: "#ffc531" },
];

const COMPARE_ROWS = [
  { product: "Hotel 4★ · 3 noches", pub: "$600", agent: "$492", save: "18%" },
  { product: "Vuelo ida y vuelta", pub: "$520", agent: "$478", save: "8%" },
  { product: "Auto de alquiler · semana", pub: "$350", agent: "$308", save: "12%" },
  { product: "Tour / experiencia", pub: "$120", agent: "$102", save: "15%" },
];

const ViajeroCompare = ({ accent }) => (
  <div className="mt-6 rounded-2xl border border-slate-200 bg-white overflow-hidden" data-testid="planes-viajero-compare">
    <div className="p-6 pb-4" style={{ background: `linear-gradient(160deg, ${accent}1f, #ffffff)` }}>
      <h4 className="text-lg font-black text-[#0f2340]">Lo mismo que buscas en las plataformas públicas… pero con precio de agente</h4>
      <p className="text-sm text-slate-600 mt-1.5">Tú reservas los mismos hoteles, vuelos y experiencias que verías aquí:</p>
      <div className="flex flex-wrap items-center gap-2.5 mt-4">
        {PUBLIC_BRANDS.map((b, i) => (
          <span key={i} className="inline-flex items-center rounded-lg px-3 py-1.5 text-sm font-black lowercase" style={{ backgroundColor: b.bg, color: b.fg }}>{b.name}</span>
        ))}
        <span className="text-xs text-slate-400 font-semibold">precios al público</span>
      </div>
    </div>
    <div className="p-4 sm:p-6 pt-2">
      <div className="grid grid-cols-[1.6fr_1fr_1fr_auto] gap-x-3 gap-y-0 text-[11px] font-black uppercase tracking-wide text-slate-400 px-2 pb-2 border-b border-slate-100">
        <div>Producto</div>
        <div className="text-center">Público</div>
        <div className="text-center" style={{ color: accent }}>Agente</div>
        <div className="text-right">Ahorro</div>
      </div>
      {COMPARE_ROWS.map((r) => (
        <div key={r.product} className="grid grid-cols-[1.6fr_1fr_1fr_auto] gap-x-3 items-center px-2 py-3 border-b border-slate-50 last:border-0">
          <div className="text-sm font-semibold text-[#0f2340]">{r.product}</div>
          <div className="text-center text-sm text-slate-400 line-through">{r.pub}</div>
          <div className="text-center text-base font-black" style={{ color: accent }}>{r.agent}</div>
          <div className="text-right"><span className="inline-block rounded-full px-2 py-0.5 text-[11px] font-black" style={{ backgroundColor: `${accent}22`, color: accent }}>−{r.save}</span></div>
        </div>
      ))}
      <p className="text-[12px] text-slate-500 mt-4 leading-relaxed">
        En <b>hotelería</b> el ahorro es mayor (hasta <b style={{ color: accent }}>20% menos</b>), porque accedes a tarifas netas de agente que las plataformas públicas no muestran. En vuelos, autos y experiencias el margen es menor pero sigue a tu favor en cada reserva.
      </p>
      <p className="text-[11px] text-slate-400 mt-2 italic">Valores referenciales para ilustrar la diferencia; el ahorro real varía según destino, fechas y disponibilidad.</p>
    </div>
  </div>
);

const PlanesEmbed = () => {
  const [selected, setSelected] = useState(null);
  const [planIdx, setPlanIdx] = useState(0);

  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    meta.setAttribute("data-planes-robots", "1");
    document.head.appendChild(meta);
    return () => { document.head.removeChild(meta); };
  }, []);

  const openCard = (key) => {
    setSelected(key);
    if (key === "agencia") setPlanIdx(0);
  };

  return (
    <div data-testid="planes-page" className="min-h-screen w-full bg-white flex flex-col">
      <header className="w-full border-b border-slate-100" data-testid="planes-header">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-4 flex items-center justify-between gap-4">
          <a href="/" data-testid="planes-logo"><img src="/logos/clubviajemos.png" alt="Club Viajemos" className="h-8 sm:h-9 w-auto" /></a>
          <nav className="flex items-center gap-5 sm:gap-8">
            <a href={LINKS.compensacion} className="hidden sm:inline text-sm font-semibold text-slate-700 hover:text-[#2F7FD0]">Compensacion</a>
            <a href={LINKS.leads} className="hidden sm:inline text-sm font-semibold text-slate-700 hover:text-[#2F7FD0]">Leads</a>
            <a href={LINKS.licencias} className="hidden sm:inline text-sm font-semibold text-slate-700 hover:text-[#2F7FD0]">Licencias</a>
            <a href={LINKS.asesor} target="_blank" rel="noopener noreferrer" className="inline-flex items-center rounded-full bg-[#1877F2] text-white text-sm font-bold px-5 py-2.5 hover:bg-[#1668d8]">Hablar con un asesor</a>
          </nav>
        </div>
      </header>

      <main className="flex-1 px-5 sm:px-8 py-12 sm:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 sm:mb-14">
            <span className="inline-block mb-6 px-4 py-1.5 rounded-full text-[12px] font-bold" style={{ backgroundColor: "#EAF2FE", color: "#2F7FD0" }}>Acceso privado · tu reunión 1 a 1</span>
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-black text-[#0f2340] leading-[0.98] tracking-tight">¿Qué quieres <span style={{ color: "#5FB228" }}>lograr</span>?</h1>
            <p className="text-base sm:text-lg text-slate-500 mt-6 max-w-2xl mx-auto">Elige tu camino. Empezamos por lo más simple y subimos hasta donde tú quieras llegar en la industria de viajes.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {CARDS.map(({ key, Icon, kicker, title, sub, single, range, valueLabel, note, iconBg, iconColor, ring }) => {
              const isSel = selected === key;
              return (
                <button type="button" key={key} onClick={() => openCard(key)} data-testid={`planes-choice-${key}`}
                  className="group relative flex flex-col text-left rounded-2xl p-7 pt-8 overflow-hidden transition-all duration-300 hover:-translate-y-1.5"
                  style={{ background: `linear-gradient(165deg, ${ring}1f 0%, ${ring}08 40%, #ffffff 100%)`, border: isSel ? `2px solid ${ring}` : `1.5px solid ${ring}55`, boxShadow: isSel ? `0 20px 45px -22px ${ring}` : `0 14px 40px -26px ${ring}` }}>
                  <div className="absolute top-0 left-0 right-0 h-1.5" style={{ backgroundColor: ring }} />
                  <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-5" style={{ backgroundColor: iconBg }}><Icon className="h-7 w-7" style={{ color: iconColor }} /></div>
                  <span className="text-[11px] font-black uppercase tracking-[1.2px] mb-2" style={{ color: ring }}>{kicker}</span>
                  <h3 className="text-xl font-black text-[#0f2340] leading-snug mb-3 min-h-[3.5rem]">{title}</h3>
                  <p className="text-sm text-slate-500 leading-relaxed mb-6 min-h-[4.5rem]">{sub}</p>
                  <div className="mt-auto w-full">
                    <div className="mb-3">
                      {range ? <div className="text-3xl font-black leading-none" style={{ color: "#2F7FD0" }}>{range[0]} <span className="text-slate-400">→</span> {range[1]}</div> : <div className="text-3xl font-black text-[#0f2340] leading-none">{single}</div>}
                      <div className="text-xs text-slate-500 mt-1.5">{valueLabel}</div>
                    </div>
                    <div className="text-xs font-bold mb-5" style={{ color: ring }}>{note}</div>
                    <span className="inline-flex items-center gap-2 text-sm font-bold group-hover:gap-3 transition-all" style={{ color: isSel ? ring : "#0f2340" }}>
                      {isSel ? "Elegido" : "Ver este camino"}<ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                    </span>
                  </div>
                </button>
              );
            })}
          </div>

          {/* Detalle simple: Ahorrar / Agente */}
          {selected === "agente" && (() => {
            const d = DETAIL_AGENTE;
            return (
              <div className="cv-reveal max-w-3xl mx-auto mt-10 rounded-3xl border overflow-hidden" style={{ borderColor: `${d.accent}66`, boxShadow: `0 24px 55px -34px ${d.accent}` }} data-testid={`planes-detail-${selected}`}>
                <div className="p-8 sm:p-10 pb-7" style={{ background: `linear-gradient(160deg, ${d.accent}2e 0%, ${d.accent}12 55%, #ffffff 100%)` }}>
                  <span className="text-[11px] font-black uppercase tracking-[2px]" style={{ color: d.accent }}>{d.kicker}</span>
                  <h2 className="text-2xl sm:text-3xl font-black text-[#0f2340] mt-2">{d.head}</h2>
                  <p className="text-slate-600 mt-3">{d.sub}</p>
                  <div className="text-xs font-bold mt-3" style={{ color: d.accent }}>{d.note}</div>
                </div>
                <div className="px-8 sm:px-10 pb-8 sm:pb-10 bg-white">
                <div className="mt-6 rounded-2xl p-6" style={{ backgroundColor: `${d.accent}14`, border: `1px solid ${d.accent}44` }}>
                  <h3 className="text-xl font-black text-[#0f2340]">{d.planName}</h3>
                  <p className="text-sm text-slate-500 mt-1.5">{d.planDesc}</p>
                  {d.big && <div className="text-3xl font-black mt-4" style={{ color: d.accent }}>{d.big} <span className="text-sm font-semibold text-slate-500">{d.bigLabel}</span></div>}
                  <div className="text-sm font-black uppercase tracking-wide text-[#0f2340] mt-5 mb-3">Incluye</div>
                  <ul className="space-y-2.5">{d.includes.map((i) => <Bullet key={i} color={d.accent}>{i}</Bullet>)}</ul>
                  <div className="mt-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                    <div><div className="text-[11px] uppercase tracking-wide text-slate-400 font-bold">{d.priceLabel}</div><div className="text-3xl font-black text-[#0f2340]">{d.price}</div></div>
                    <a href={d.link} data-testid={`planes-cta-${selected}`} className="inline-flex items-center justify-center gap-2 rounded-xl px-6 py-4 font-bold text-white" style={{ backgroundColor: d.accent }}>{d.cta}<ArrowRight className="h-4 w-4" /></a>
                  </div>
                </div>
                <p className="text-sm text-slate-600 mt-6 italic">{d.upsell}</p>
                </div>
              </div>
            );
          })()}

          {/* Detalle Agencia: escalera de 3 planes */}
          {selected === "agencia" && (() => {
            const p = PLANS[planIdx];
            return (
              <div className="cv-reveal max-w-4xl mx-auto mt-10" data-testid="planes-detail-agencia">
                <div className="text-center mb-6">
                  <span className="text-[11px] font-black uppercase tracking-[2px] text-[#2F7FD0]">Camino del Dueño · Escalera de ambición</span>
                  <h2 className="text-2xl sm:text-3xl font-black text-[#0f2340] mt-2">Cada nivel desbloquea una versión mayor de tu negocio.</h2>
                  <p className="text-slate-500 mt-3">Sube un peldaño a la vez. Más comisión, más override, y más trabajo que deja de ser tuyo para hacerse solo.</p>
                </div>

                {/* Override fácil */}
                <div className="rounded-2xl bg-slate-50 border border-slate-200 p-6 mb-8">
                  <div className="text-sm font-black uppercase tracking-wide text-[#2F7FD0] mb-1">El override, fácil fácil</div>
                  <p className="text-sm text-slate-500 mb-5">Es como enseñar a alguien a vender y recibir una propina de cada venta suya — para siempre, aunque estés durmiendo.</p>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                    {OVERRIDE_STEPS.map((s) => (
                      <div key={s.n} className="rounded-xl bg-white border border-slate-200 p-4">
                        <div className="text-2xl font-black text-[#2F7FD0]">{s.n}</div>
                        <div className="font-bold text-[#0f2340] mt-1">{s.t}</div>
                        <div className="text-xs text-slate-500 mt-1">{s.d}</div>
                      </div>
                    ))}
                  </div>
                  <p className="text-xs text-slate-500 mt-4">Tu agente vende <b>1 viaje</b> → a ti te llega <b>una propina</b>. Trabajas UNA vez (cuando le enseñas). Cobras MUCHAS veces (en cada venta suya).</p>
                </div>

                {/* Tabs de planes */}
                <div className="flex flex-wrap gap-2 justify-center mb-6" data-testid="planes-tabs">
                  {PLANS.map((pl, i) => (
                    <button key={pl.key} type="button" onClick={() => setPlanIdx(i)} data-testid={`planes-tab-${pl.key}`}
                      className="px-4 py-2 rounded-full text-sm font-bold transition-all"
                      style={{ backgroundColor: planIdx === i ? pl.accent : "#f1f5f9", color: planIdx === i ? (pl.blue ? "#fff" : "#0f2340") : "#64748b" }}>
                      {pl.name}
                    </button>
                  ))}
                </div>

                {/* Panel del plan seleccionado */}
                <div className="relative rounded-3xl p-8 sm:p-10 sm:pt-12" data-testid={`planes-plan-${p.key}`}
                  style={p.blue ? { background: "linear-gradient(165deg,#0e2250 0%,#17386e 55%,#1d4486 100%)", border: `1.5px solid ${p.accent}66`, boxShadow: `0 30px 70px -40px ${p.accent}` } : { background: `linear-gradient(165deg, ${p.accent}26 0%, ${p.accent}0a 45%, #ffffff 100%)`, border: `2px solid ${p.accent}80`, boxShadow: `0 24px 55px -34px ${p.accent}` }}>
                  {p.topBadge && (
                    <div className="absolute -top-4 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full px-5 py-2 text-[12px] font-black text-[#0a1f44] shadow-lg" style={{ backgroundColor: p.accent }} data-testid="planes-empire-topbadge">
                      ★ {p.topBadge}
                    </div>
                  )}
                  {p.blue ? (
                    <span className="inline-block rounded-full px-3 py-1 text-[11px] font-black uppercase tracking-[1.5px] mb-4" style={{ backgroundColor: "rgba(255,255,255,0.1)", color: p.accent, border: `1px solid ${p.accent}55` }}>{p.vibe}</span>
                  ) : (
                    <div className="text-[11px] font-black uppercase tracking-[2px] mb-1" style={{ color: p.accent }}>{p.level}</div>
                  )}
                  {p.popular && <span className="inline-block text-[10px] font-black uppercase bg-[#8B5CF6] text-white rounded-full px-2.5 py-0.5 mb-2">Más elegido</span>}
                  <h3 className={`text-3xl sm:text-4xl font-black ${p.blue ? "text-white" : "text-[#0f2340]"}`}>{p.blue ? p.name : `${p.vibe} · ${p.name}`}</h3>
                  <p className={`mt-2 ${p.blue ? "text-slate-200" : "text-slate-500"}`}>{p.headline}</p>

                  <div className="mt-6">
                    <div className="text-5xl font-black leading-none" style={{ color: p.accent }}>{p.big}</div>
                    <div className={`text-sm mt-1.5 ${p.blue ? "text-slate-300" : "text-slate-500"}`}>{p.bigLabel}</div>
                  </div>

                  <div className="mt-5 rounded-2xl p-4" style={p.blue ? { backgroundColor: "rgba(255,255,255,0.07)", border: `1px solid ${p.accent}44` } : { backgroundColor: `${p.accent}1f`, border: `1px solid ${p.accent}55` }}>
                    <div className="text-sm font-black" style={{ color: p.accent }}>⚄ {p.overrideLabel}</div>
                    <div className={`text-sm mt-1 ${p.blue ? "text-slate-200" : "text-slate-600"}`}>{p.overrideDesc}</div>
                  </div>

                  <div className={`text-sm font-black uppercase tracking-wide mt-6 mb-3 ${p.blue ? "" : "text-[#0f2340]"}`} style={p.blue ? { color: p.accent } : {}}>{p.newTitle}</div>
                  {p.blue ? (
                    <ul className="space-y-2.5">{p.newItems.map((i) => (
                      <li key={i} className="flex items-center gap-3 rounded-xl px-4 py-3" style={{ backgroundColor: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.08)" }}>
                        <span className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center" style={{ backgroundColor: `${p.accent}2e` }}><Check className="h-3.5 w-3.5" style={{ color: p.accent }} /></span>
                        <span className="text-sm font-bold text-white">{i}</span>
                      </li>
                    ))}</ul>
                  ) : (
                    <ul className="space-y-2.5">{p.newItems.map((i) => (
                      <li key={i} className="flex items-start gap-2.5 text-sm leading-relaxed">
                        <Sparkles className="h-4 w-4 flex-shrink-0 mt-0.5" style={{ color: p.accent }} />
                        <span className="text-slate-600">{i}</span>
                      </li>
                    ))}</ul>
                  )}

                  {p.also && (
                    <div className="mt-6">
                      <div className={`text-xs font-bold uppercase tracking-wide mb-2 ${p.blue ? "text-slate-300" : "text-slate-400"}`}>{p.alsoTitle}</div>
                      <ul className="space-y-1.5">{p.also.map((i) => (
                        <li key={i} className={`flex items-start gap-2 text-[13px] ${p.blue ? "text-slate-300" : "text-slate-500"}`}>
                          <Check className="h-3.5 w-3.5 flex-shrink-0 mt-0.5" style={{ color: p.accent }} /><span>{i}</span>
                        </li>
                      ))}</ul>
                    </div>
                  )}

                  <div className="mt-7 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                    <div><div className={`text-[11px] uppercase tracking-wide font-bold ${p.blue ? "text-slate-300" : "text-slate-400"}`}>Inversión única</div><div className={`text-3xl font-black ${p.blue ? "text-white" : "text-[#0f2340]"}`}>{p.price}</div></div>
                    {p.last ? (
                      <a href={LINKS.agencia} data-testid="planes-plan-cta" className="inline-flex items-center justify-center gap-2 rounded-xl px-6 py-4 font-black text-[#0a1f44]" style={{ backgroundColor: p.accent }}>{p.cta}<ArrowRight className="h-4 w-4" /></a>
                    ) : (
                      <button type="button" onClick={() => setPlanIdx(planIdx + 1)} data-testid="planes-plan-next" className="inline-flex items-center justify-center gap-2 rounded-xl px-6 py-4 font-bold text-white" style={{ backgroundColor: p.accent }}>{p.cta}<ArrowRight className="h-4 w-4" /></button>
                    )}
                  </div>
                  {p.last && <p className={`text-sm mt-5 ${p.blue ? "text-slate-200" : "text-slate-500"}`}>Llegaste al nivel máximo. Aquí es donde todos quieren estar.</p>}
                </div>

                <p className="text-center text-slate-500 mt-8">Tu próximo destino empieza hoy. Elige quién quieres ser. Nosotros ponemos las plataformas, la capacitación y el soporte de por vida.</p>
              </div>
            );
          })()}
        </div>
      </main>

      <footer className="w-full bg-[#0a1428] py-6 px-5 text-center" data-testid="planes-footer">
        <p className="text-[13px] text-slate-300">Club Viajemos · Travel Empire — Sección privada. Datos mockeados para revisión. Licencias y Registros ST39568.</p>
      </footer>
    </div>
  );
};

export default PlanesEmbed;
